'use client';

import { useToast } from '@/components/ui/use-toast';
import { getLogger } from '@/logger/logger';
import { removeItemsFromCart } from '@/store/cart/cart.store';
import { CartItem } from '@/types/cart.types';
import { CartRemovalScope } from '@/types/enums/analytics/cart/cart-analytics.enum';
import { trackCartItemsRemoved } from '@/utils/cart/cart-analytics.util';

export const REMOVE_FROM_CART_ERROR_MESSAGE = 'Não foi possível remover do carrinho. Tente novamente.';

const logger = getLogger('cart.remove-from-cart');

export interface UseRemoveFromCartResult {
  removeItem: (item: CartItem) => Promise<boolean>;
  removeItems: (items: CartItem[], scope: CartRemovalScope) => Promise<boolean>;
}

export function useRemoveFromCart(): UseRemoveFromCartResult {
  const { toast } = useToast();

  async function remove(items: CartItem[], scope: CartRemovalScope): Promise<boolean> {
    const cartItemsIds = items.map((item) => item.id);

    try {
      const cart = await removeItemsFromCart(cartItemsIds);

      trackCartItemsRemoved(scope, items, cart?.items ?? []);

      return true;
    } catch (error) {
      logger.error('Failed to remove items from the cart', {
        cart: { event: 'remove_failed', cart_item_ids: cartItemsIds },
        error,
      });
      toast.error(REMOVE_FROM_CART_ERROR_MESSAGE);

      return false;
    }
  }

  return {
    removeItem: (item: CartItem) => remove([item], CartRemovalScope.ITEM),
    removeItems: remove,
  };
}
